import React from 'react'

interface DisplayContainerProps {
  display: string
  result: number
  backspace: () => void
  handleInputChange: (e: any) => void
}

function DisplayContainer(props: DisplayContainerProps) {
  const {
    display, result, backspace, handleInputChange,
  } = props

  return (
    <div className="display-container mb-3">
      <div className="display">
        <div className="input-group input-group-lg mb-3">
          <input
            type="text"
            className="form-control form-control-lg text-end"
            name="inputField"
            value={display}
            autoComplete="off"
            onChange={handleInputChange}
          />
        </div>
        <div className="input-group input-group-lg">
          <input
            type="text"
            className="form-control text-end"
            name="resultField"
            value={result}
            disabled
          />
        </div>
      </div>
    </div>
  )
}

export default DisplayContainer
